import './app.css'
import './tailwind.css'

import { IntlProvider } from 'react-intl'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from '@tanstack/react-router'

import { isLocalEnv } from '@/config'

import { defaultRichTextElements, useLocalization } from './localise'
import { queryClient } from './query-client'
import { createRouter } from './router'

const router = createRouter()

export const App = () => {
  const { lang, messages } = useLocalization()

  return (
    <QueryClientProvider client={queryClient}>
      <IntlProvider
        defaultRichTextElements={defaultRichTextElements}
        locale={lang}
        messages={messages as unknown as Record<string, string>}
      >
        <div>
          <RouterProviderWithContext />
        </div>
      </IntlProvider>
      {isLocalEnv() && <ReactQueryDevtools />}
    </QueryClientProvider>
  )
}

const RouterProviderWithContext = () => {
  return <RouterProvider router={router} />
}
